module.exports = __webpack_public_path__ + "img/HZ-B5021.254a4186.jpg";